"use strict";

define('rs/error/error.controller',['require','exports','module','e3-modal','underscore','rs/error/error.view','rs/errors','jquery'],function (require, exports, module) {
  var E3Modal = require('e3-modal');
  var _ = require('underscore');
  var ErrorSectionView = require('rs/error/error.view');
  var RSErrors = require('rs/errors');
  var $ = require('jquery');
  var ErrorSectionController = E3Modal.SectionController.extend({
    getServerCallStackFromXML: function getServerCallStackFromXML(responseText) {
      var responseTextNodes = $(responseText);
      var respText = '';
      responseTextNodes.each(function () {
        var nodeName = this.nodeName.toLowerCase();
        if (nodeName === 'title' || nodeName === 'p' || nodeName === 'pre') {
          respText += this.innerText + '\n\n';
        }
      });
      return respText;
    },
    setupView: function setupView() {
      this.setView(new ErrorSectionView());
    },
    addMessage: function addMessage(errorObject) {
      var message = '',
        id = 0,
        details = null;
      if (_.isObject(errorObject)) {
        if (_.isFunction(errorObject.error)) {
          id = errorObject.status;
          message = "An HTTP error occured making a request to the server.";
          details = {};
          details.requestMethod = errorObject.methodType;
          details.summary = errorObject.status + " " + errorObject.statusText;
          details.requestUrl = errorObject.url;
        } else if (errorObject instanceof RSErrors.HTTPError) {
          var serverError = errorObject.serverResponse.error;
          details = {};
          details.summary = errorObject.message;
          details.stackTrace = errorObject.stack;
          if (_.isString(serverError)) {
            message = serverError;
          } else {
            message = serverError.message || 'An error occurred loading the error message from the server.';
          }
          if (serverError.detail && Object.getOwnPropertyNames(serverError.detail).length > 0) {
            details = {};
            details.stackTrace = serverError.detail['Traceable Error Code'] || '';
          }
        } else if (errorObject instanceof Error && errorObject.stack && errorObject.stack.includes('heartbeat')) {
          details = {};
          message = 'Error connecting to the server, please verify your connection.';
          details.summary = 'error sending heartbeat';
          details.stackTrace = this.getServerCallStackFromXML(errorObject.xhr.responseText);
        } else if (errorObject instanceof Error && errorObject.stack) {
          details = {};
          message = errorObject.message;
          details.stackTrace = errorObject.stack;
          details.summary = errorObject.message;
        } else if (errorObject instanceof Error) {
          message = errorObject.message || errorObject.toString();
        }
      } else if (_.isString(errorObject)) {
        message = errorObject;
      }
      this.getView().addMessage(id, message, details);
    }
  });
  module.exports = ErrorSectionController;
});

